/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public/route'
import { Route as ProtectedRouteImport } from './routes/_protected/route'
import { Route as ProtectedIndexImport } from './routes/_protected/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login/route'
import { Route as ProtectedAdminRouteImport } from './routes/_protected/admin/route'
import { Route as ProtectedTenantKeyRouteImport } from './routes/_protected/$tenantKey/route'
import { Route as PublicLoginIndexImport } from './routes/_public/login/index'
import { Route as ProtectedAdminIndexImport } from './routes/_protected/admin/index'
import { Route as ProtectedTenantKeyIndexImport } from './routes/_protected/$tenantKey/index'
import { Route as PublicLoginCognitoRouteImport } from './routes/_public/login/cognito/route'
import { Route as PublicLoginCallbackRouteImport } from './routes/_public/login/callback/route'
import { Route as ProtectedTenantKeyVehicleDispatchBoardsRouteImport } from './routes/_protected/$tenantKey/vehicle-dispatch-boards/route'
import { Route as ProtectedTenantKeyTourImportJobsRouteImport } from './routes/_protected/$tenantKey/tour-import-jobs/route'
import { Route as ProtectedTenantKeyShipmentOrdersRouteImport } from './routes/_protected/$tenantKey/shipment-orders/route'
import { Route as ProtectedTenantKeyShipmentOrderImportJobsRouteImport } from './routes/_protected/$tenantKey/shipment-order-import-jobs/route'
import { Route as ProtectedTenantKeySettingsRouteImport } from './routes/_protected/$tenantKey/settings/route'
import { Route as ProtectedTenantKeyPerformancemanagementsRouteImport } from './routes/_protected/$tenantKey/_performance_managements/route'
import { Route as ProtectedTenantKeyVehicleDispatchBoardsIndexImport } from './routes/_protected/$tenantKey/vehicle-dispatch-boards/index'
import { Route as ProtectedTenantKeyTourImportJobsIndexImport } from './routes/_protected/$tenantKey/tour-import-jobs/index'
import { Route as ProtectedTenantKeyShipmentOrderImportJobsIndexImport } from './routes/_protected/$tenantKey/shipment-order-import-jobs/index'
import { Route as ProtectedTenantKeySettingsIndexImport } from './routes/_protected/$tenantKey/settings/index'
import { Route as ProtectedTenantKeySettingsTrucksRouteImport } from './routes/_protected/$tenantKey/settings/trucks/route'
import { Route as ProtectedTenantKeySettingsTruckTypeImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/truck-type-import-jobs/route'
import { Route as ProtectedTenantKeySettingsTruckModelsRouteImport } from './routes/_protected/$tenantKey/settings/truck-models/route'
import { Route as ProtectedTenantKeySettingsTruckModelImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/truck-model-import-jobs/route'
import { Route as ProtectedTenantKeySettingsTruckImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/truck-import-jobs/route'
import { Route as ProtectedTenantKeySettingsTruckClassImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/truck-class-import-jobs/route'
import { Route as ProtectedTenantKeySettingsTariffImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/tariff-import-jobs/route'
import { Route as ProtectedTenantKeySettingsSubPartnersRouteImport } from './routes/_protected/$tenantKey/settings/sub-partners/route'
import { Route as ProtectedTenantKeySettingsSitesRouteImport } from './routes/_protected/$tenantKey/settings/sites/route'
import { Route as ProtectedTenantKeySettingsSiteImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/site-import-jobs/route'
import { Route as ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/shipment-category-import-jobs/route'
import { Route as ProtectedTenantKeySettingsShipmentCategoriesRouteImport } from './routes/_protected/$tenantKey/settings/shipment-categories/route'
import { Route as ProtectedTenantKeySettingsPlanSlotsRouteImport } from './routes/_protected/$tenantKey/settings/plan-slots/route'
import { Route as ProtectedTenantKeySettingsPartnersRouteImport } from './routes/_protected/$tenantKey/settings/partners/route'
import { Route as ProtectedTenantKeySettingsPackageCategoryImportJobsRouteImport } from './routes/_protected/$tenantKey/settings/package-category-import-jobs/route'
import { Route as ProtectedTenantKeySettingsPackageCategoriesRouteImport } from './routes/_protected/$tenantKey/settings/package-categories/route'
import { Route as ProtectedTenantKeySettingsOwnPartnerRouteImport } from './routes/_protected/$tenantKey/settings/own-partner/route'
import { Route as ProtectedTenantKeySettingsDriversRouteImport } from './routes/_protected/$tenantKey/settings/drivers/route'
import { Route as ProtectedTenantKeySettingsCustomersRouteImport } from './routes/_protected/$tenantKey/settings/customers/route'
import { Route as ProtectedTenantKeySettingsCustomerContractsRouteImport } from './routes/_protected/$tenantKey/settings/customer-contracts/route'
import { Route as ProtectedTenantKeySettingsContractsRouteImport } from './routes/_protected/$tenantKey/settings/contracts/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/route'
import { Route as ProtectedTenantKeyPerformancemanagementsToursRouteImport } from './routes/_protected/$tenantKey/_performance_managements/tours/route'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/route'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/route'
import { Route as ProtectedTenantKeySettingsTrucksIndexImport } from './routes/_protected/$tenantKey/settings/trucks/index'
import { Route as ProtectedTenantKeySettingsTruckTypeImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/truck-type-import-jobs/index'
import { Route as ProtectedTenantKeySettingsTruckModelsIndexImport } from './routes/_protected/$tenantKey/settings/truck-models/index'
import { Route as ProtectedTenantKeySettingsTruckModelImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/truck-model-import-jobs/index'
import { Route as ProtectedTenantKeySettingsTruckImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/truck-import-jobs/index'
import { Route as ProtectedTenantKeySettingsTruckClassImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/truck-class-import-jobs/index'
import { Route as ProtectedTenantKeySettingsTariffImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/tariff-import-jobs/index'
import { Route as ProtectedTenantKeySettingsSubPartnersIndexImport } from './routes/_protected/$tenantKey/settings/sub-partners/index'
import { Route as ProtectedTenantKeySettingsSitesIndexImport } from './routes/_protected/$tenantKey/settings/sites/index'
import { Route as ProtectedTenantKeySettingsSiteImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/site-import-jobs/index'
import { Route as ProtectedTenantKeySettingsShipmentCategoryImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/shipment-category-import-jobs/index'
import { Route as ProtectedTenantKeySettingsShipmentCategoriesIndexImport } from './routes/_protected/$tenantKey/settings/shipment-categories/index'
import { Route as ProtectedTenantKeySettingsPlanSlotsIndexImport } from './routes/_protected/$tenantKey/settings/plan-slots/index'
import { Route as ProtectedTenantKeySettingsPartnersIndexImport } from './routes/_protected/$tenantKey/settings/partners/index'
import { Route as ProtectedTenantKeySettingsPackageCategoryImportJobsIndexImport } from './routes/_protected/$tenantKey/settings/package-category-import-jobs/index'
import { Route as ProtectedTenantKeySettingsPackageCategoriesIndexImport } from './routes/_protected/$tenantKey/settings/package-categories/index'
import { Route as ProtectedTenantKeySettingsOwnPartnerIndexImport } from './routes/_protected/$tenantKey/settings/own-partner/index'
import { Route as ProtectedTenantKeySettingsDriversIndexImport } from './routes/_protected/$tenantKey/settings/drivers/index'
import { Route as ProtectedTenantKeySettingsCustomersIndexImport } from './routes/_protected/$tenantKey/settings/customers/index'
import { Route as ProtectedTenantKeySettingsCustomerContractsIndexImport } from './routes/_protected/$tenantKey/settings/customer-contracts/index'
import { Route as ProtectedTenantKeySettingsCustomKeySettingsIndexImport } from './routes/_protected/$tenantKey/settings/custom-key-settings/index'
import { Route as ProtectedTenantKeySettingsContractsIndexImport } from './routes/_protected/$tenantKey/settings/contracts/index'
import { Route as ProtectedTenantKeyPerformancemanagementsToursIndexImport } from './routes/_protected/$tenantKey/_performance_managements/tours/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/index'
import { Route as ProtectedTenantKeySettingsTrucksCreateRouteImport } from './routes/_protected/$tenantKey/settings/trucks/create/route'
import { Route as ProtectedTenantKeySettingsTrucksTruckIdRouteImport } from './routes/_protected/$tenantKey/settings/trucks/$truckId/route'
import { Route as ProtectedTenantKeySettingsTruckModelsCreateRouteImport } from './routes/_protected/$tenantKey/settings/truck-models/create/route'
import { Route as ProtectedTenantKeySettingsTruckModelsTruckModelIdRouteImport } from './routes/_protected/$tenantKey/settings/truck-models/$truckModelId/route'
import { Route as ProtectedTenantKeySettingsSubPartnersCreateRouteImport } from './routes/_protected/$tenantKey/settings/sub-partners/create/route'
import { Route as ProtectedTenantKeySettingsSubPartnersSubPartnerIdRouteImport } from './routes/_protected/$tenantKey/settings/sub-partners/$subPartnerId/route'
import { Route as ProtectedTenantKeySettingsSitesCreateRouteImport } from './routes/_protected/$tenantKey/settings/sites/create/route'
import { Route as ProtectedTenantKeySettingsSitesSiteIdRouteImport } from './routes/_protected/$tenantKey/settings/sites/$siteId/route'
import { Route as ProtectedTenantKeySettingsShipmentCategoriesCreateRouteImport } from './routes/_protected/$tenantKey/settings/shipment-categories/create/route'
import { Route as ProtectedTenantKeySettingsShipmentCategoriesShipmentCategoryIdRouteImport } from './routes/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId/route'
import { Route as ProtectedTenantKeySettingsPartnersCreateRouteImport } from './routes/_protected/$tenantKey/settings/partners/create/route'
import { Route as ProtectedTenantKeySettingsPartnersPartnerIdRouteImport } from './routes/_protected/$tenantKey/settings/partners/$partnerId/route'
import { Route as ProtectedTenantKeySettingsPackageCategoriesCreateRouteImport } from './routes/_protected/$tenantKey/settings/package-categories/create/route'
import { Route as ProtectedTenantKeySettingsPackageCategoriesPackageCategoryIdRouteImport } from './routes/_protected/$tenantKey/settings/package-categories/$packageCategoryId/route'
import { Route as ProtectedTenantKeySettingsDriversCreateRouteImport } from './routes/_protected/$tenantKey/settings/drivers/create/route'
import { Route as ProtectedTenantKeySettingsDriversUserIdRouteImport } from './routes/_protected/$tenantKey/settings/drivers/$userId/route'
import { Route as ProtectedTenantKeySettingsCustomersCreateRouteImport } from './routes/_protected/$tenantKey/settings/customers/create/route'
import { Route as ProtectedTenantKeySettingsCustomersCustomerIdRouteImport } from './routes/_protected/$tenantKey/settings/customers/$customerId/route'
import { Route as ProtectedTenantKeySettingsCustomerContractsCreateRouteImport } from './routes/_protected/$tenantKey/settings/customer-contracts/create/route'
import { Route as ProtectedTenantKeySettingsCustomerContractsCustomerContractIdRouteImport } from './routes/_protected/$tenantKey/settings/customer-contracts/$customerContractId/route'
import { Route as ProtectedTenantKeySettingsContractsCreateRouteImport } from './routes/_protected/$tenantKey/settings/contracts/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/in-house/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/areas/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/route'
import { Route as ProtectedTenantKeyPerformancemanagementsToursCreateRouteImport } from './routes/_protected/$tenantKey/_performance_managements/tours/create/route'
import { Route as ProtectedTenantKeyPerformancemanagementsToursTourIdRouteImport } from './routes/_protected/$tenantKey/_performance_managements/tours/$tourId/route'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/route'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsInHouseIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/in-house/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAreasIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/areas/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsDateRangeDetailIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsDateRangeDetailIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/index'
import { Route as ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdIndexImport } from './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/index'
import { Route as ProtectedTenantKeySettingsContractsTourCreateRouteImport } from './routes/_protected/$tenantKey/settings/contracts/tour/create/route'
import { Route as ProtectedTenantKeySettingsContractsTourContractIdRouteImport } from './routes/_protected/$tenantKey/settings/contracts/tour/$contractId/route'
import { Route as ProtectedTenantKeySettingsContractsTariffCreateRouteImport } from './routes/_protected/$tenantKey/settings/contracts/tariff/create/route'
import { Route as ProtectedTenantKeySettingsContractsTariffContractIdRouteImport } from './routes/_protected/$tenantKey/settings/contracts/tariff/$contractId/route'
import { Route as ProtectedTenantKeySettingsContractsCharterCreateRouteImport } from './routes/_protected/$tenantKey/settings/contracts/charter/create/route'
import { Route as ProtectedTenantKeySettingsContractsCharterContractIdRouteImport } from './routes/_protected/$tenantKey/settings/contracts/charter/$contractId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesTruckTypeIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesTruckClassIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesTaxCategoryIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsItemUnitIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesChargeTypeIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAreasCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/areas/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAreasAreaIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesAdditionalPaymentCategoryIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersIndexImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/index'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersUserIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersCreateRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create/route'
import { Route as ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersUserIdRouteImport } from './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId/route'

// Create/Update Routes

const PublicRouteRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRouteRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedIndexRoute = ProtectedIndexImport.update({
  path: '/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const PublicLoginRouteRoute = PublicLoginRouteImport.update({
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)

const ProtectedAdminRouteRoute = ProtectedAdminRouteImport.update({
  path: '/admin',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedTenantKeyRouteRoute = ProtectedTenantKeyRouteImport.update({
  path: '/$tenantKey',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const PublicLoginIndexRoute = PublicLoginIndexImport.update({
  path: '/',
  getParentRoute: () => PublicLoginRouteRoute,
} as any).lazy(() =>
  import('./routes/_public/login/index.lazy').then((d) => d.Route),
)

const ProtectedAdminIndexRoute = ProtectedAdminIndexImport.update({
  path: '/',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_protected/admin/index.lazy').then((d) => d.Route),
)

const ProtectedTenantKeyIndexRoute = ProtectedTenantKeyIndexImport.update({
  path: '/',
  getParentRoute: () => ProtectedTenantKeyRouteRoute,
} as any).lazy(() =>
  import('./routes/_protected/$tenantKey/index.lazy').then((d) => d.Route),
)

const PublicLoginCognitoRouteRoute = PublicLoginCognitoRouteImport.update({
  path: '/cognito',
  getParentRoute: () => PublicLoginRouteRoute,
} as any)

const PublicLoginCallbackRouteRoute = PublicLoginCallbackRouteImport.update({
  path: '/callback',
  getParentRoute: () => PublicLoginRouteRoute,
} as any).lazy(() =>
  import('./routes/_public/login/callback/route.lazy').then((d) => d.Route),
)

const ProtectedTenantKeyVehicleDispatchBoardsRouteRoute =
  ProtectedTenantKeyVehicleDispatchBoardsRouteImport.update({
    path: '/vehicle-dispatch-boards',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeyTourImportJobsRouteRoute =
  ProtectedTenantKeyTourImportJobsRouteImport.update({
    path: '/tour-import-jobs',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeyShipmentOrdersRouteRoute =
  ProtectedTenantKeyShipmentOrdersRouteImport.update({
    path: '/shipment-orders',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeyShipmentOrderImportJobsRouteRoute =
  ProtectedTenantKeyShipmentOrderImportJobsRouteImport.update({
    path: '/shipment-order-import-jobs',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeySettingsRouteRoute =
  ProtectedTenantKeySettingsRouteImport.update({
    path: '/settings',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeyPerformancemanagementsRouteRoute =
  ProtectedTenantKeyPerformancemanagementsRouteImport.update({
    id: '/_performance_managements',
    getParentRoute: () => ProtectedTenantKeyRouteRoute,
  } as any)

const ProtectedTenantKeyVehicleDispatchBoardsIndexRoute =
  ProtectedTenantKeyVehicleDispatchBoardsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeyVehicleDispatchBoardsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/vehicle-dispatch-boards/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyTourImportJobsIndexRoute =
  ProtectedTenantKeyTourImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeyTourImportJobsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/tour-import-jobs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeyShipmentOrderImportJobsIndexRoute =
  ProtectedTenantKeyShipmentOrderImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeyShipmentOrderImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/shipment-order-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsIndexRoute =
  ProtectedTenantKeySettingsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTrucksRouteRoute =
  ProtectedTenantKeySettingsTrucksRouteImport.update({
    path: '/trucks',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTruckTypeImportJobsRouteRoute =
  ProtectedTenantKeySettingsTruckTypeImportJobsRouteImport.update({
    path: '/truck-type-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTruckModelsRouteRoute =
  ProtectedTenantKeySettingsTruckModelsRouteImport.update({
    path: '/truck-models',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTruckModelImportJobsRouteRoute =
  ProtectedTenantKeySettingsTruckModelImportJobsRouteImport.update({
    path: '/truck-model-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTruckImportJobsRouteRoute =
  ProtectedTenantKeySettingsTruckImportJobsRouteImport.update({
    path: '/truck-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTruckClassImportJobsRouteRoute =
  ProtectedTenantKeySettingsTruckClassImportJobsRouteImport.update({
    path: '/truck-class-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsTariffImportJobsRouteRoute =
  ProtectedTenantKeySettingsTariffImportJobsRouteImport.update({
    path: '/tariff-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSubPartnersRouteRoute =
  ProtectedTenantKeySettingsSubPartnersRouteImport.update({
    path: '/sub-partners',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSitesRouteRoute =
  ProtectedTenantKeySettingsSitesRouteImport.update({
    path: '/sites',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSiteImportJobsRouteRoute =
  ProtectedTenantKeySettingsSiteImportJobsRouteImport.update({
    path: '/site-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteRoute =
  ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteImport.update({
    path: '/shipment-category-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsShipmentCategoriesRouteRoute =
  ProtectedTenantKeySettingsShipmentCategoriesRouteImport.update({
    path: '/shipment-categories',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsPlanSlotsRouteRoute =
  ProtectedTenantKeySettingsPlanSlotsRouteImport.update({
    path: '/plan-slots',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsPartnersRouteRoute =
  ProtectedTenantKeySettingsPartnersRouteImport.update({
    path: '/partners',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsPackageCategoryImportJobsRouteRoute =
  ProtectedTenantKeySettingsPackageCategoryImportJobsRouteImport.update({
    path: '/package-category-import-jobs',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsPackageCategoriesRouteRoute =
  ProtectedTenantKeySettingsPackageCategoriesRouteImport.update({
    path: '/package-categories',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsOwnPartnerRouteRoute =
  ProtectedTenantKeySettingsOwnPartnerRouteImport.update({
    path: '/own-partner',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsDriversRouteRoute =
  ProtectedTenantKeySettingsDriversRouteImport.update({
    path: '/drivers',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsCustomersRouteRoute =
  ProtectedTenantKeySettingsCustomersRouteImport.update({
    path: '/customers',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsCustomerContractsRouteRoute =
  ProtectedTenantKeySettingsCustomerContractsRouteImport.update({
    path: '/customer-contracts',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsContractsRouteRoute =
  ProtectedTenantKeySettingsContractsRouteImport.update({
    path: '/contracts',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsRouteImport.update({
    id: '/_system-master-settings',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any)

const ProtectedTenantKeyPerformancemanagementsToursRouteRoute =
  ProtectedTenantKeyPerformancemanagementsToursRouteImport.update({
    path: '/tours',
    getParentRoute: () => ProtectedTenantKeyPerformancemanagementsRouteRoute,
  } as any)

const ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport.update({
    path: '/monthly-tour-reports',
    getParentRoute: () => ProtectedTenantKeyPerformancemanagementsRouteRoute,
  } as any)

const ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport.update(
    {
      path: '/monthly-customer-reports',
      getParentRoute: () => ProtectedTenantKeyPerformancemanagementsRouteRoute,
    } as any,
  )

const ProtectedTenantKeySettingsTrucksIndexRoute =
  ProtectedTenantKeySettingsTrucksIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsTrucksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/trucks/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeySettingsTruckTypeImportJobsIndexRoute =
  ProtectedTenantKeySettingsTruckTypeImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsTruckTypeImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-type-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckModelsIndexRoute =
  ProtectedTenantKeySettingsTruckModelsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsTruckModelsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-models/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckModelImportJobsIndexRoute =
  ProtectedTenantKeySettingsTruckModelImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsTruckModelImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-model-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckImportJobsIndexRoute =
  ProtectedTenantKeySettingsTruckImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsTruckImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckClassImportJobsIndexRoute =
  ProtectedTenantKeySettingsTruckClassImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsTruckClassImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-class-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTariffImportJobsIndexRoute =
  ProtectedTenantKeySettingsTariffImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsTariffImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/tariff-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSubPartnersIndexRoute =
  ProtectedTenantKeySettingsSubPartnersIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsSubPartnersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/sub-partners/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSitesIndexRoute =
  ProtectedTenantKeySettingsSitesIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsSitesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/sites/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeySettingsSiteImportJobsIndexRoute =
  ProtectedTenantKeySettingsSiteImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsSiteImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/site-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsShipmentCategoryImportJobsIndexRoute =
  ProtectedTenantKeySettingsShipmentCategoryImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/shipment-category-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsShipmentCategoriesIndexRoute =
  ProtectedTenantKeySettingsShipmentCategoriesIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsShipmentCategoriesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/shipment-categories/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPlanSlotsIndexRoute =
  ProtectedTenantKeySettingsPlanSlotsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsPlanSlotsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/plan-slots/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPartnersIndexRoute =
  ProtectedTenantKeySettingsPartnersIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsPartnersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/partners/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeySettingsPackageCategoryImportJobsIndexRoute =
  ProtectedTenantKeySettingsPackageCategoryImportJobsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsPackageCategoryImportJobsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/package-category-import-jobs/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPackageCategoriesIndexRoute =
  ProtectedTenantKeySettingsPackageCategoriesIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsPackageCategoriesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/package-categories/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsOwnPartnerIndexRoute =
  ProtectedTenantKeySettingsOwnPartnerIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsOwnPartnerRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/own-partner/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsDriversIndexRoute =
  ProtectedTenantKeySettingsDriversIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsDriversRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/drivers/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeySettingsCustomersIndexRoute =
  ProtectedTenantKeySettingsCustomersIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsCustomersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/customers/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeySettingsCustomerContractsIndexRoute =
  ProtectedTenantKeySettingsCustomerContractsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsCustomerContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/customer-contracts/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsCustomKeySettingsIndexRoute =
  ProtectedTenantKeySettingsCustomKeySettingsIndexImport.update({
    path: '/custom-key-settings/',
    getParentRoute: () => ProtectedTenantKeySettingsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/custom-key-settings/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsIndexRoute =
  ProtectedTenantKeySettingsContractsIndexImport.update({
    path: '/',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$tenantKey/settings/contracts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedTenantKeyPerformancemanagementsToursIndexRoute =
  ProtectedTenantKeyPerformancemanagementsToursIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeyPerformancemanagementsToursRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/tours/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTrucksCreateRouteRoute =
  ProtectedTenantKeySettingsTrucksCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsTrucksRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/trucks/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTrucksTruckIdRouteRoute =
  ProtectedTenantKeySettingsTrucksTruckIdRouteImport.update({
    path: '/$truckId',
    getParentRoute: () => ProtectedTenantKeySettingsTrucksRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/trucks/$truckId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckModelsCreateRouteRoute =
  ProtectedTenantKeySettingsTruckModelsCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsTruckModelsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-models/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsTruckModelsTruckModelIdRouteRoute =
  ProtectedTenantKeySettingsTruckModelsTruckModelIdRouteImport.update({
    path: '/$truckModelId',
    getParentRoute: () => ProtectedTenantKeySettingsTruckModelsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/truck-models/$truckModelId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSubPartnersCreateRouteRoute =
  ProtectedTenantKeySettingsSubPartnersCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsSubPartnersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/sub-partners/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSubPartnersSubPartnerIdRouteRoute =
  ProtectedTenantKeySettingsSubPartnersSubPartnerIdRouteImport.update({
    path: '/$subPartnerId',
    getParentRoute: () => ProtectedTenantKeySettingsSubPartnersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/sub-partners/$subPartnerId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSitesCreateRouteRoute =
  ProtectedTenantKeySettingsSitesCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsSitesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/sites/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSitesSiteIdRouteRoute =
  ProtectedTenantKeySettingsSitesSiteIdRouteImport.update({
    path: '/$siteId',
    getParentRoute: () => ProtectedTenantKeySettingsSitesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/sites/$siteId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsShipmentCategoriesCreateRouteRoute =
  ProtectedTenantKeySettingsShipmentCategoriesCreateRouteImport.update({
    path: '/create',
    getParentRoute: () =>
      ProtectedTenantKeySettingsShipmentCategoriesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/shipment-categories/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsShipmentCategoriesShipmentCategoryIdRouteRoute =
  ProtectedTenantKeySettingsShipmentCategoriesShipmentCategoryIdRouteImport.update(
    {
      path: '/$shipmentCategoryId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsShipmentCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPartnersCreateRouteRoute =
  ProtectedTenantKeySettingsPartnersCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsPartnersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/partners/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPartnersPartnerIdRouteRoute =
  ProtectedTenantKeySettingsPartnersPartnerIdRouteImport.update({
    path: '/$partnerId',
    getParentRoute: () => ProtectedTenantKeySettingsPartnersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/partners/$partnerId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPackageCategoriesCreateRouteRoute =
  ProtectedTenantKeySettingsPackageCategoriesCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsPackageCategoriesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/package-categories/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsPackageCategoriesPackageCategoryIdRouteRoute =
  ProtectedTenantKeySettingsPackageCategoriesPackageCategoryIdRouteImport.update(
    {
      path: '/$packageCategoryId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsPackageCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/package-categories/$packageCategoryId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsDriversCreateRouteRoute =
  ProtectedTenantKeySettingsDriversCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsDriversRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/drivers/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsDriversUserIdRouteRoute =
  ProtectedTenantKeySettingsDriversUserIdRouteImport.update({
    path: '/$userId',
    getParentRoute: () => ProtectedTenantKeySettingsDriversRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/drivers/$userId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsCustomersCreateRouteRoute =
  ProtectedTenantKeySettingsCustomersCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsCustomersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/customers/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsCustomersCustomerIdRouteRoute =
  ProtectedTenantKeySettingsCustomersCustomerIdRouteImport.update({
    path: '/$customerId',
    getParentRoute: () => ProtectedTenantKeySettingsCustomersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/customers/$customerId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsCustomerContractsCreateRouteRoute =
  ProtectedTenantKeySettingsCustomerContractsCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsCustomerContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/customer-contracts/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsCustomerContractsCustomerContractIdRouteRoute =
  ProtectedTenantKeySettingsCustomerContractsCustomerContractIdRouteImport.update(
    {
      path: '/$customerContractId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsCustomerContractsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/customer-contracts/$customerContractId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsCreateRouteRoute =
  ProtectedTenantKeySettingsContractsCreateRouteImport.update({
    path: '/create',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport.update({
    path: '/truck-types',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport.update({
    path: '/truck-classes',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport.update(
    {
      path: '/tax-categories',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
    } as any,
  )

const ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport.update({
    path: '/item-units',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteImport.update({
    path: '/in-house',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport.update({
    path: '/charge-types',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport.update({
    path: '/areas',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport.update(
    {
      path: '/additional-payment-categories',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
    } as any,
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteImport.update({
    id: '/_users',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute,
  } as any)

const ProtectedTenantKeyPerformancemanagementsToursCreateRouteRoute =
  ProtectedTenantKeyPerformancemanagementsToursCreateRouteImport.update({
    path: '/create',
    getParentRoute: () =>
      ProtectedTenantKeyPerformancemanagementsToursRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/tours/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsToursTourIdRouteRoute =
  ProtectedTenantKeyPerformancemanagementsToursTourIdRouteImport.update({
    path: '/$tourId',
    getParentRoute: () =>
      ProtectedTenantKeyPerformancemanagementsToursRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/tours/$tourId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteImport.update(
    {
      path: '/$monthlyTourReportId',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute,
    } as any,
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteImport.update(
    {
      path: '/$monthlyCustomerReportId',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute,
    } as any,
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsInHouseIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsInHouseIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/in-house/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAreasIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAreasIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/areas/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsDateRangeDetailIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsDateRangeDetailIndexImport.update(
    {
      path: '/date-range-detail/',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsDateRangeDetailIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsDateRangeDetailIndexImport.update(
    {
      path: '/date-range-detail/',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdIndexRoute =
  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsTourCreateRouteRoute =
  ProtectedTenantKeySettingsContractsTourCreateRouteImport.update({
    path: '/tour/create',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/tour/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsTourContractIdRouteRoute =
  ProtectedTenantKeySettingsContractsTourContractIdRouteImport.update({
    path: '/tour/$contractId',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/tour/$contractId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsTariffCreateRouteRoute =
  ProtectedTenantKeySettingsContractsTariffCreateRouteImport.update({
    path: '/tariff/create',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/tariff/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsTariffContractIdRouteRoute =
  ProtectedTenantKeySettingsContractsTariffContractIdRouteImport.update({
    path: '/tariff/$contractId',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/tariff/$contractId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsCharterCreateRouteRoute =
  ProtectedTenantKeySettingsContractsCharterCreateRouteImport.update({
    path: '/charter/create',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/charter/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsContractsCharterContractIdRouteRoute =
  ProtectedTenantKeySettingsContractsCharterContractIdRouteImport.update({
    path: '/charter/$contractId',
    getParentRoute: () => ProtectedTenantKeySettingsContractsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/contracts/charter/$contractId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesTruckTypeIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesTruckTypeIdRouteImport.update(
    {
      path: '/$truckTypeId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesTruckClassIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesTruckClassIdRouteImport.update(
    {
      path: '/$truckClassId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesTaxCategoryIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesTaxCategoryIdRouteImport.update(
    {
      path: '/$taxCategoryId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsItemUnitIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsItemUnitIdRouteImport.update(
    {
      path: '/$ItemUnitId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesChargeTypeIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesChargeTypeIdRouteImport.update(
    {
      path: '/$chargeTypeId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAreasCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAreasCreateRouteImport.update({
    path: '/create',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/areas/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAreasAreaIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAreasAreaIdRouteImport.update({
    path: '/$areaId',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesAdditionalPaymentCategoryIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesAdditionalPaymentCategoryIdRouteImport.update(
    {
      path: '/$additionalPaymentCategoryId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport.update(
    {
      path: '/partner-users',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteRoute,
    } as any,
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport.update({
    path: '/dc-users',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteRoute,
  } as any)

const ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersIndexRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersIndexImport.update({
    path: '/',
    getParentRoute: () =>
      ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/index.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersUserIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersUserIdRouteImport.update(
    {
      path: '/$userId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersCreateRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersCreateRouteImport.update(
    {
      path: '/create',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create/route.lazy'
    ).then((d) => d.Route),
  )

const ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersUserIdRouteRoute =
  ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersUserIdRouteImport.update(
    {
      path: '/$userId',
      getParentRoute: () =>
        ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId/route.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/_protected/$tenantKey': {
      id: '/_protected/$tenantKey'
      path: '/$tenantKey'
      fullPath: '/$tenantKey'
      preLoaderRoute: typeof ProtectedTenantKeyRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/$tenantKey/_performance_managements': {
      id: '/_protected/$tenantKey/_performance_managements'
      path: ''
      fullPath: '/$tenantKey'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/$tenantKey/settings': {
      id: '/_protected/$tenantKey/settings'
      path: '/settings'
      fullPath: '/$tenantKey/settings'
      preLoaderRoute: typeof ProtectedTenantKeySettingsRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/$tenantKey/shipment-order-import-jobs': {
      id: '/_protected/$tenantKey/shipment-order-import-jobs'
      path: '/shipment-order-import-jobs'
      fullPath: '/$tenantKey/shipment-order-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeyShipmentOrderImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/$tenantKey/shipment-orders': {
      id: '/_protected/$tenantKey/shipment-orders'
      path: '/shipment-orders'
      fullPath: '/$tenantKey/shipment-orders'
      preLoaderRoute: typeof ProtectedTenantKeyShipmentOrdersRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/$tenantKey/tour-import-jobs': {
      id: '/_protected/$tenantKey/tour-import-jobs'
      path: '/tour-import-jobs'
      fullPath: '/$tenantKey/tour-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeyTourImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/$tenantKey/vehicle-dispatch-boards': {
      id: '/_protected/$tenantKey/vehicle-dispatch-boards'
      path: '/vehicle-dispatch-boards'
      fullPath: '/$tenantKey/vehicle-dispatch-boards'
      preLoaderRoute: typeof ProtectedTenantKeyVehicleDispatchBoardsRouteImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_public/login/callback': {
      id: '/_public/login/callback'
      path: '/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof PublicLoginCallbackRouteImport
      parentRoute: typeof PublicLoginRouteImport
    }
    '/_public/login/cognito': {
      id: '/_public/login/cognito'
      path: '/cognito'
      fullPath: '/login/cognito'
      preLoaderRoute: typeof PublicLoginCognitoRouteImport
      parentRoute: typeof PublicLoginRouteImport
    }
    '/_protected/$tenantKey/': {
      id: '/_protected/$tenantKey/'
      path: '/'
      fullPath: '/$tenantKey/'
      preLoaderRoute: typeof ProtectedTenantKeyIndexImport
      parentRoute: typeof ProtectedTenantKeyRouteImport
    }
    '/_protected/admin/': {
      id: '/_protected/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof ProtectedAdminIndexImport
      parentRoute: typeof ProtectedAdminRouteImport
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexImport
      parentRoute: typeof PublicLoginRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-customer-reports': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-customer-reports'
      path: '/monthly-customer-reports'
      fullPath: '/$tenantKey/monthly-customer-reports'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-tour-reports': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-tour-reports'
      path: '/monthly-tour-reports'
      fullPath: '/$tenantKey/monthly-tour-reports'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/tours': {
      id: '/_protected/$tenantKey/_performance_managements/tours'
      path: '/tours'
      fullPath: '/$tenantKey/tours'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsToursRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings': {
      id: '/_protected/$tenantKey/settings/_system-master-settings'
      path: ''
      fullPath: '/$tenantKey/settings'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts': {
      id: '/_protected/$tenantKey/settings/contracts'
      path: '/contracts'
      fullPath: '/$tenantKey/settings/contracts'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/customer-contracts': {
      id: '/_protected/$tenantKey/settings/customer-contracts'
      path: '/customer-contracts'
      fullPath: '/$tenantKey/settings/customer-contracts'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomerContractsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/customers': {
      id: '/_protected/$tenantKey/settings/customers'
      path: '/customers'
      fullPath: '/$tenantKey/settings/customers'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/drivers': {
      id: '/_protected/$tenantKey/settings/drivers'
      path: '/drivers'
      fullPath: '/$tenantKey/settings/drivers'
      preLoaderRoute: typeof ProtectedTenantKeySettingsDriversRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/own-partner': {
      id: '/_protected/$tenantKey/settings/own-partner'
      path: '/own-partner'
      fullPath: '/$tenantKey/settings/own-partner'
      preLoaderRoute: typeof ProtectedTenantKeySettingsOwnPartnerRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/package-categories': {
      id: '/_protected/$tenantKey/settings/package-categories'
      path: '/package-categories'
      fullPath: '/$tenantKey/settings/package-categories'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoriesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/package-category-import-jobs': {
      id: '/_protected/$tenantKey/settings/package-category-import-jobs'
      path: '/package-category-import-jobs'
      fullPath: '/$tenantKey/settings/package-category-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoryImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/partners': {
      id: '/_protected/$tenantKey/settings/partners'
      path: '/partners'
      fullPath: '/$tenantKey/settings/partners'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPartnersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/plan-slots': {
      id: '/_protected/$tenantKey/settings/plan-slots'
      path: '/plan-slots'
      fullPath: '/$tenantKey/settings/plan-slots'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPlanSlotsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-categories': {
      id: '/_protected/$tenantKey/settings/shipment-categories'
      path: '/shipment-categories'
      fullPath: '/$tenantKey/settings/shipment-categories'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-category-import-jobs': {
      id: '/_protected/$tenantKey/settings/shipment-category-import-jobs'
      path: '/shipment-category-import-jobs'
      fullPath: '/$tenantKey/settings/shipment-category-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/site-import-jobs': {
      id: '/_protected/$tenantKey/settings/site-import-jobs'
      path: '/site-import-jobs'
      fullPath: '/$tenantKey/settings/site-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSiteImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/sites': {
      id: '/_protected/$tenantKey/settings/sites'
      path: '/sites'
      fullPath: '/$tenantKey/settings/sites'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSitesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/sub-partners': {
      id: '/_protected/$tenantKey/settings/sub-partners'
      path: '/sub-partners'
      fullPath: '/$tenantKey/settings/sub-partners'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSubPartnersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/tariff-import-jobs': {
      id: '/_protected/$tenantKey/settings/tariff-import-jobs'
      path: '/tariff-import-jobs'
      fullPath: '/$tenantKey/settings/tariff-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTariffImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-class-import-jobs': {
      id: '/_protected/$tenantKey/settings/truck-class-import-jobs'
      path: '/truck-class-import-jobs'
      fullPath: '/$tenantKey/settings/truck-class-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckClassImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-import-jobs': {
      id: '/_protected/$tenantKey/settings/truck-import-jobs'
      path: '/truck-import-jobs'
      fullPath: '/$tenantKey/settings/truck-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-model-import-jobs': {
      id: '/_protected/$tenantKey/settings/truck-model-import-jobs'
      path: '/truck-model-import-jobs'
      fullPath: '/$tenantKey/settings/truck-model-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-models': {
      id: '/_protected/$tenantKey/settings/truck-models'
      path: '/truck-models'
      fullPath: '/$tenantKey/settings/truck-models'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-type-import-jobs': {
      id: '/_protected/$tenantKey/settings/truck-type-import-jobs'
      path: '/truck-type-import-jobs'
      fullPath: '/$tenantKey/settings/truck-type-import-jobs'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckTypeImportJobsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/trucks': {
      id: '/_protected/$tenantKey/settings/trucks'
      path: '/trucks'
      fullPath: '/$tenantKey/settings/trucks'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTrucksRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/': {
      id: '/_protected/$tenantKey/settings/'
      path: '/'
      fullPath: '/$tenantKey/settings/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/shipment-order-import-jobs/': {
      id: '/_protected/$tenantKey/shipment-order-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/shipment-order-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeyShipmentOrderImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeyShipmentOrderImportJobsRouteImport
    }
    '/_protected/$tenantKey/tour-import-jobs/': {
      id: '/_protected/$tenantKey/tour-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/tour-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeyTourImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeyTourImportJobsRouteImport
    }
    '/_protected/$tenantKey/vehicle-dispatch-boards/': {
      id: '/_protected/$tenantKey/vehicle-dispatch-boards/'
      path: '/'
      fullPath: '/$tenantKey/vehicle-dispatch-boards/'
      preLoaderRoute: typeof ProtectedTenantKeyVehicleDispatchBoardsIndexImport
      parentRoute: typeof ProtectedTenantKeyVehicleDispatchBoardsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId'
      path: '/$monthlyCustomerReportId'
      fullPath: '/$tenantKey/monthly-customer-reports/$monthlyCustomerReportId'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId'
      path: '/$monthlyTourReportId'
      fullPath: '/$tenantKey/monthly-tour-reports/$monthlyTourReportId'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/tours/$tourId': {
      id: '/_protected/$tenantKey/_performance_managements/tours/$tourId'
      path: '/$tourId'
      fullPath: '/$tenantKey/tours/$tourId'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsToursTourIdRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsToursRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/tours/create': {
      id: '/_protected/$tenantKey/_performance_managements/tours/create'
      path: '/create'
      fullPath: '/$tenantKey/tours/create'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsToursCreateRouteImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsToursRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users'
      path: ''
      fullPath: '/$tenantKey/settings'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories'
      path: '/additional-payment-categories'
      fullPath: '/$tenantKey/settings/additional-payment-categories'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/areas': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/areas'
      path: '/areas'
      fullPath: '/$tenantKey/settings/areas'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/charge-types': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/charge-types'
      path: '/charge-types'
      fullPath: '/$tenantKey/settings/charge-types'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/in-house': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/in-house'
      path: '/in-house'
      fullPath: '/$tenantKey/settings/in-house'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/item-units': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/item-units'
      path: '/item-units'
      fullPath: '/$tenantKey/settings/item-units'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/tax-categories': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/tax-categories'
      path: '/tax-categories'
      fullPath: '/$tenantKey/settings/tax-categories'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-classes': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-classes'
      path: '/truck-classes'
      fullPath: '/$tenantKey/settings/truck-classes'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-types': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-types'
      path: '/truck-types'
      fullPath: '/$tenantKey/settings/truck-types'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/create': {
      id: '/_protected/$tenantKey/settings/contracts/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/contracts/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/customer-contracts/$customerContractId': {
      id: '/_protected/$tenantKey/settings/customer-contracts/$customerContractId'
      path: '/$customerContractId'
      fullPath: '/$tenantKey/settings/customer-contracts/$customerContractId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomerContractsCustomerContractIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomerContractsRouteImport
    }
    '/_protected/$tenantKey/settings/customer-contracts/create': {
      id: '/_protected/$tenantKey/settings/customer-contracts/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/customer-contracts/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomerContractsCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomerContractsRouteImport
    }
    '/_protected/$tenantKey/settings/customers/$customerId': {
      id: '/_protected/$tenantKey/settings/customers/$customerId'
      path: '/$customerId'
      fullPath: '/$tenantKey/settings/customers/$customerId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomersCustomerIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomersRouteImport
    }
    '/_protected/$tenantKey/settings/customers/create': {
      id: '/_protected/$tenantKey/settings/customers/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/customers/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomersCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomersRouteImport
    }
    '/_protected/$tenantKey/settings/drivers/$userId': {
      id: '/_protected/$tenantKey/settings/drivers/$userId'
      path: '/$userId'
      fullPath: '/$tenantKey/settings/drivers/$userId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsDriversUserIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsDriversRouteImport
    }
    '/_protected/$tenantKey/settings/drivers/create': {
      id: '/_protected/$tenantKey/settings/drivers/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/drivers/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsDriversCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsDriversRouteImport
    }
    '/_protected/$tenantKey/settings/package-categories/$packageCategoryId': {
      id: '/_protected/$tenantKey/settings/package-categories/$packageCategoryId'
      path: '/$packageCategoryId'
      fullPath: '/$tenantKey/settings/package-categories/$packageCategoryId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoriesPackageCategoryIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsPackageCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/package-categories/create': {
      id: '/_protected/$tenantKey/settings/package-categories/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/package-categories/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoriesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsPackageCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/partners/$partnerId': {
      id: '/_protected/$tenantKey/settings/partners/$partnerId'
      path: '/$partnerId'
      fullPath: '/$tenantKey/settings/partners/$partnerId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPartnersPartnerIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/partners/create': {
      id: '/_protected/$tenantKey/settings/partners/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/partners/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPartnersCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId': {
      id: '/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId'
      path: '/$shipmentCategoryId'
      fullPath: '/$tenantKey/settings/shipment-categories/$shipmentCategoryId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesShipmentCategoryIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-categories/create': {
      id: '/_protected/$tenantKey/settings/shipment-categories/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/shipment-categories/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/sites/$siteId': {
      id: '/_protected/$tenantKey/settings/sites/$siteId'
      path: '/$siteId'
      fullPath: '/$tenantKey/settings/sites/$siteId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSitesSiteIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSitesRouteImport
    }
    '/_protected/$tenantKey/settings/sites/create': {
      id: '/_protected/$tenantKey/settings/sites/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/sites/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSitesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSitesRouteImport
    }
    '/_protected/$tenantKey/settings/sub-partners/$subPartnerId': {
      id: '/_protected/$tenantKey/settings/sub-partners/$subPartnerId'
      path: '/$subPartnerId'
      fullPath: '/$tenantKey/settings/sub-partners/$subPartnerId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSubPartnersSubPartnerIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSubPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/sub-partners/create': {
      id: '/_protected/$tenantKey/settings/sub-partners/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/sub-partners/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSubPartnersCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSubPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/truck-models/$truckModelId': {
      id: '/_protected/$tenantKey/settings/truck-models/$truckModelId'
      path: '/$truckModelId'
      fullPath: '/$tenantKey/settings/truck-models/$truckModelId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelsTruckModelIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckModelsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-models/create': {
      id: '/_protected/$tenantKey/settings/truck-models/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/truck-models/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelsCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckModelsRouteImport
    }
    '/_protected/$tenantKey/settings/trucks/$truckId': {
      id: '/_protected/$tenantKey/settings/trucks/$truckId'
      path: '/$truckId'
      fullPath: '/$tenantKey/settings/trucks/$truckId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTrucksTruckIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsTrucksRouteImport
    }
    '/_protected/$tenantKey/settings/trucks/create': {
      id: '/_protected/$tenantKey/settings/trucks/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/trucks/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTrucksCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsTrucksRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/'
      path: '/'
      fullPath: '/$tenantKey/monthly-customer-reports/'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/'
      path: '/'
      fullPath: '/$tenantKey/monthly-tour-reports/'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/tours/': {
      id: '/_protected/$tenantKey/_performance_managements/tours/'
      path: '/'
      fullPath: '/$tenantKey/tours/'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsToursIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsToursRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/': {
      id: '/_protected/$tenantKey/settings/contracts/'
      path: '/'
      fullPath: '/$tenantKey/settings/contracts/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/custom-key-settings/': {
      id: '/_protected/$tenantKey/settings/custom-key-settings/'
      path: '/custom-key-settings'
      fullPath: '/$tenantKey/settings/custom-key-settings'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomKeySettingsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsRouteImport
    }
    '/_protected/$tenantKey/settings/customer-contracts/': {
      id: '/_protected/$tenantKey/settings/customer-contracts/'
      path: '/'
      fullPath: '/$tenantKey/settings/customer-contracts/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomerContractsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomerContractsRouteImport
    }
    '/_protected/$tenantKey/settings/customers/': {
      id: '/_protected/$tenantKey/settings/customers/'
      path: '/'
      fullPath: '/$tenantKey/settings/customers/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsCustomersIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsCustomersRouteImport
    }
    '/_protected/$tenantKey/settings/drivers/': {
      id: '/_protected/$tenantKey/settings/drivers/'
      path: '/'
      fullPath: '/$tenantKey/settings/drivers/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsDriversIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsDriversRouteImport
    }
    '/_protected/$tenantKey/settings/own-partner/': {
      id: '/_protected/$tenantKey/settings/own-partner/'
      path: '/'
      fullPath: '/$tenantKey/settings/own-partner/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsOwnPartnerIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsOwnPartnerRouteImport
    }
    '/_protected/$tenantKey/settings/package-categories/': {
      id: '/_protected/$tenantKey/settings/package-categories/'
      path: '/'
      fullPath: '/$tenantKey/settings/package-categories/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoriesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsPackageCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/package-category-import-jobs/': {
      id: '/_protected/$tenantKey/settings/package-category-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/package-category-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPackageCategoryImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsPackageCategoryImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/partners/': {
      id: '/_protected/$tenantKey/settings/partners/'
      path: '/'
      fullPath: '/$tenantKey/settings/partners/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPartnersIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/plan-slots/': {
      id: '/_protected/$tenantKey/settings/plan-slots/'
      path: '/'
      fullPath: '/$tenantKey/settings/plan-slots/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsPlanSlotsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsPlanSlotsRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-categories/': {
      id: '/_protected/$tenantKey/settings/shipment-categories/'
      path: '/'
      fullPath: '/$tenantKey/settings/shipment-categories/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsShipmentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/shipment-category-import-jobs/': {
      id: '/_protected/$tenantKey/settings/shipment-category-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/shipment-category-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsShipmentCategoryImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/site-import-jobs/': {
      id: '/_protected/$tenantKey/settings/site-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/site-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSiteImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSiteImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/sites/': {
      id: '/_protected/$tenantKey/settings/sites/'
      path: '/'
      fullPath: '/$tenantKey/settings/sites/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSitesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSitesRouteImport
    }
    '/_protected/$tenantKey/settings/sub-partners/': {
      id: '/_protected/$tenantKey/settings/sub-partners/'
      path: '/'
      fullPath: '/$tenantKey/settings/sub-partners/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSubPartnersIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSubPartnersRouteImport
    }
    '/_protected/$tenantKey/settings/tariff-import-jobs/': {
      id: '/_protected/$tenantKey/settings/tariff-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/tariff-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTariffImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTariffImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-class-import-jobs/': {
      id: '/_protected/$tenantKey/settings/truck-class-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-class-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckClassImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckClassImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-import-jobs/': {
      id: '/_protected/$tenantKey/settings/truck-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-model-import-jobs/': {
      id: '/_protected/$tenantKey/settings/truck-model-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-model-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckModelImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-models/': {
      id: '/_protected/$tenantKey/settings/truck-models/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-models/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckModelsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckModelsRouteImport
    }
    '/_protected/$tenantKey/settings/truck-type-import-jobs/': {
      id: '/_protected/$tenantKey/settings/truck-type-import-jobs/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-type-import-jobs/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTruckTypeImportJobsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTruckTypeImportJobsRouteImport
    }
    '/_protected/$tenantKey/settings/trucks/': {
      id: '/_protected/$tenantKey/settings/trucks/'
      path: '/'
      fullPath: '/$tenantKey/settings/trucks/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsTrucksIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsTrucksRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users'
      path: '/dc-users'
      fullPath: '/$tenantKey/settings/dc-users'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users'
      path: '/partner-users'
      fullPath: '/$tenantKey/settings/partner-users'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId'
      path: '/$additionalPaymentCategoryId'
      fullPath: '/$tenantKey/settings/additional-payment-categories/$additionalPaymentCategoryId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesAdditionalPaymentCategoryIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/additional-payment-categories/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId'
      path: '/$areaId'
      fullPath: '/$tenantKey/settings/areas/$areaId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasAreaIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/areas/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/areas/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/areas/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId'
      path: '/$chargeTypeId'
      fullPath: '/$tenantKey/settings/charge-types/$chargeTypeId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesChargeTypeIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/charge-types/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/charge-types/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/charge-types/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId'
      path: '/$ItemUnitId'
      fullPath: '/$tenantKey/settings/item-units/$ItemUnitId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsItemUnitIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/item-units/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/item-units/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/item-units/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId'
      path: '/$taxCategoryId'
      fullPath: '/$tenantKey/settings/tax-categories/$taxCategoryId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesTaxCategoryIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/tax-categories/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId'
      path: '/$truckClassId'
      fullPath: '/$tenantKey/settings/truck-classes/$truckClassId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesTruckClassIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/truck-classes/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId'
      path: '/$truckTypeId'
      fullPath: '/$tenantKey/settings/truck-types/$truckTypeId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesTruckTypeIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-types/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-types/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/truck-types/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/charter/$contractId': {
      id: '/_protected/$tenantKey/settings/contracts/charter/$contractId'
      path: '/charter/$contractId'
      fullPath: '/$tenantKey/settings/contracts/charter/$contractId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsCharterContractIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/charter/create': {
      id: '/_protected/$tenantKey/settings/contracts/charter/create'
      path: '/charter/create'
      fullPath: '/$tenantKey/settings/contracts/charter/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsCharterCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/tariff/$contractId': {
      id: '/_protected/$tenantKey/settings/contracts/tariff/$contractId'
      path: '/tariff/$contractId'
      fullPath: '/$tenantKey/settings/contracts/tariff/$contractId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsTariffContractIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/tariff/create': {
      id: '/_protected/$tenantKey/settings/contracts/tariff/create'
      path: '/tariff/create'
      fullPath: '/$tenantKey/settings/contracts/tariff/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsTariffCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/tour/$contractId': {
      id: '/_protected/$tenantKey/settings/contracts/tour/$contractId'
      path: '/tour/$contractId'
      fullPath: '/$tenantKey/settings/contracts/tour/$contractId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsTourContractIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/settings/contracts/tour/create': {
      id: '/_protected/$tenantKey/settings/contracts/tour/create'
      path: '/tour/create'
      fullPath: '/$tenantKey/settings/contracts/tour/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsContractsTourCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsContractsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/'
      path: '/'
      fullPath: '/$tenantKey/monthly-customer-reports/$monthlyCustomerReportId/'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/'
      path: '/date-range-detail'
      fullPath: '/$tenantKey/monthly-customer-reports/date-range-detail'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsDateRangeDetailIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/'
      path: '/'
      fullPath: '/$tenantKey/monthly-tour-reports/$monthlyTourReportId/'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteImport
    }
    '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/': {
      id: '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/'
      path: '/date-range-detail'
      fullPath: '/$tenantKey/monthly-tour-reports/date-range-detail'
      preLoaderRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsDateRangeDetailIndexImport
      parentRoute: typeof ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/'
      path: '/'
      fullPath: '/$tenantKey/settings/additional-payment-categories/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/areas/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/areas/'
      path: '/'
      fullPath: '/$tenantKey/settings/areas/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/charge-types/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/charge-types/'
      path: '/'
      fullPath: '/$tenantKey/settings/charge-types/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/in-house/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/in-house/'
      path: '/'
      fullPath: '/$tenantKey/settings/in-house/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsInHouseIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/item-units/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/item-units/'
      path: '/'
      fullPath: '/$tenantKey/settings/item-units/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/'
      path: '/'
      fullPath: '/$tenantKey/settings/tax-categories/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-classes/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/truck-types/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/truck-types/'
      path: '/'
      fullPath: '/$tenantKey/settings/truck-types/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId'
      path: '/$userId'
      fullPath: '/$tenantKey/settings/dc-users/$userId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersUserIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/dc-users/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId'
      path: '/$userId'
      fullPath: '/$tenantKey/settings/partner-users/$userId'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersUserIdRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create'
      path: '/create'
      fullPath: '/$tenantKey/settings/partner-users/create'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersCreateRouteImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/'
      path: '/'
      fullPath: '/$tenantKey/settings/dc-users/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteImport
    }
    '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/': {
      id: '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/'
      path: '/'
      fullPath: '/$tenantKey/settings/partner-users/'
      preLoaderRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersIndexImport
      parentRoute: typeof ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  ProtectedRouteRoute: ProtectedRouteRoute.addChildren({
    ProtectedTenantKeyRouteRoute: ProtectedTenantKeyRouteRoute.addChildren({
      ProtectedTenantKeyPerformancemanagementsRouteRoute:
        ProtectedTenantKeyPerformancemanagementsRouteRoute.addChildren({
          ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute:
            ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsRouteRoute.addChildren(
              {
                ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteRoute:
                  ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdRouteRoute.addChildren(
                    {
                      ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsMonthlyCustomerReportIdIndexRoute,
                    },
                  ),
                ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsIndexRoute,
                ProtectedTenantKeyPerformancemanagementsMonthlyCustomerReportsDateRangeDetailIndexRoute,
              },
            ),
          ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute:
            ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsRouteRoute.addChildren(
              {
                ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteRoute:
                  ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdRouteRoute.addChildren(
                    {
                      ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsMonthlyTourReportIdIndexRoute,
                    },
                  ),
                ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsIndexRoute,
                ProtectedTenantKeyPerformancemanagementsMonthlyTourReportsDateRangeDetailIndexRoute,
              },
            ),
          ProtectedTenantKeyPerformancemanagementsToursRouteRoute:
            ProtectedTenantKeyPerformancemanagementsToursRouteRoute.addChildren(
              {
                ProtectedTenantKeyPerformancemanagementsToursTourIdRouteRoute,
                ProtectedTenantKeyPerformancemanagementsToursCreateRouteRoute,
                ProtectedTenantKeyPerformancemanagementsToursIndexRoute,
              },
            ),
        }),
      ProtectedTenantKeySettingsRouteRoute:
        ProtectedTenantKeySettingsRouteRoute.addChildren({
          ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute:
            ProtectedTenantKeySettingsSystemMasterSettingsRouteRoute.addChildren(
              {
                ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsUsersRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute:
                        ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersRouteRoute.addChildren(
                          {
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersUserIdRouteRoute,
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersCreateRouteRoute,
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersDcUsersIndexRoute,
                          },
                        ),
                      ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute:
                        ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersRouteRoute.addChildren(
                          {
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersUserIdRouteRoute,
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersCreateRouteRoute,
                            ProtectedTenantKeySettingsSystemMasterSettingsUsersPartnerUsersIndexRoute,
                          },
                        ),
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesAdditionalPaymentCategoryIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsAdditionalPaymentCategoriesIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsAreasRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsAreasAreaIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsAreasCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsAreasIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesChargeTypeIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsChargeTypesIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsInHouseRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsInHouseIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsItemUnitIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsItemUnitsIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesTaxCategoryIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTaxCategoriesIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesTruckClassIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckClassesIndexRoute,
                    },
                  ),
                ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute:
                  ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesRouteRoute.addChildren(
                    {
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesTruckTypeIdRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesCreateRouteRoute,
                      ProtectedTenantKeySettingsSystemMasterSettingsTruckTypesIndexRoute,
                    },
                  ),
              },
            ),
          ProtectedTenantKeySettingsContractsRouteRoute:
            ProtectedTenantKeySettingsContractsRouteRoute.addChildren({
              ProtectedTenantKeySettingsContractsCreateRouteRoute,
              ProtectedTenantKeySettingsContractsIndexRoute,
              ProtectedTenantKeySettingsContractsCharterContractIdRouteRoute,
              ProtectedTenantKeySettingsContractsCharterCreateRouteRoute,
              ProtectedTenantKeySettingsContractsTariffContractIdRouteRoute,
              ProtectedTenantKeySettingsContractsTariffCreateRouteRoute,
              ProtectedTenantKeySettingsContractsTourContractIdRouteRoute,
              ProtectedTenantKeySettingsContractsTourCreateRouteRoute,
            }),
          ProtectedTenantKeySettingsCustomerContractsRouteRoute:
            ProtectedTenantKeySettingsCustomerContractsRouteRoute.addChildren({
              ProtectedTenantKeySettingsCustomerContractsCustomerContractIdRouteRoute,
              ProtectedTenantKeySettingsCustomerContractsCreateRouteRoute,
              ProtectedTenantKeySettingsCustomerContractsIndexRoute,
            }),
          ProtectedTenantKeySettingsCustomersRouteRoute:
            ProtectedTenantKeySettingsCustomersRouteRoute.addChildren({
              ProtectedTenantKeySettingsCustomersCustomerIdRouteRoute,
              ProtectedTenantKeySettingsCustomersCreateRouteRoute,
              ProtectedTenantKeySettingsCustomersIndexRoute,
            }),
          ProtectedTenantKeySettingsDriversRouteRoute:
            ProtectedTenantKeySettingsDriversRouteRoute.addChildren({
              ProtectedTenantKeySettingsDriversUserIdRouteRoute,
              ProtectedTenantKeySettingsDriversCreateRouteRoute,
              ProtectedTenantKeySettingsDriversIndexRoute,
            }),
          ProtectedTenantKeySettingsOwnPartnerRouteRoute:
            ProtectedTenantKeySettingsOwnPartnerRouteRoute.addChildren({
              ProtectedTenantKeySettingsOwnPartnerIndexRoute,
            }),
          ProtectedTenantKeySettingsPackageCategoriesRouteRoute:
            ProtectedTenantKeySettingsPackageCategoriesRouteRoute.addChildren({
              ProtectedTenantKeySettingsPackageCategoriesPackageCategoryIdRouteRoute,
              ProtectedTenantKeySettingsPackageCategoriesCreateRouteRoute,
              ProtectedTenantKeySettingsPackageCategoriesIndexRoute,
            }),
          ProtectedTenantKeySettingsPackageCategoryImportJobsRouteRoute:
            ProtectedTenantKeySettingsPackageCategoryImportJobsRouteRoute.addChildren(
              { ProtectedTenantKeySettingsPackageCategoryImportJobsIndexRoute },
            ),
          ProtectedTenantKeySettingsPartnersRouteRoute:
            ProtectedTenantKeySettingsPartnersRouteRoute.addChildren({
              ProtectedTenantKeySettingsPartnersPartnerIdRouteRoute,
              ProtectedTenantKeySettingsPartnersCreateRouteRoute,
              ProtectedTenantKeySettingsPartnersIndexRoute,
            }),
          ProtectedTenantKeySettingsPlanSlotsRouteRoute:
            ProtectedTenantKeySettingsPlanSlotsRouteRoute.addChildren({
              ProtectedTenantKeySettingsPlanSlotsIndexRoute,
            }),
          ProtectedTenantKeySettingsShipmentCategoriesRouteRoute:
            ProtectedTenantKeySettingsShipmentCategoriesRouteRoute.addChildren({
              ProtectedTenantKeySettingsShipmentCategoriesShipmentCategoryIdRouteRoute,
              ProtectedTenantKeySettingsShipmentCategoriesCreateRouteRoute,
              ProtectedTenantKeySettingsShipmentCategoriesIndexRoute,
            }),
          ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteRoute:
            ProtectedTenantKeySettingsShipmentCategoryImportJobsRouteRoute.addChildren(
              {
                ProtectedTenantKeySettingsShipmentCategoryImportJobsIndexRoute,
              },
            ),
          ProtectedTenantKeySettingsSiteImportJobsRouteRoute:
            ProtectedTenantKeySettingsSiteImportJobsRouteRoute.addChildren({
              ProtectedTenantKeySettingsSiteImportJobsIndexRoute,
            }),
          ProtectedTenantKeySettingsSitesRouteRoute:
            ProtectedTenantKeySettingsSitesRouteRoute.addChildren({
              ProtectedTenantKeySettingsSitesSiteIdRouteRoute,
              ProtectedTenantKeySettingsSitesCreateRouteRoute,
              ProtectedTenantKeySettingsSitesIndexRoute,
            }),
          ProtectedTenantKeySettingsSubPartnersRouteRoute:
            ProtectedTenantKeySettingsSubPartnersRouteRoute.addChildren({
              ProtectedTenantKeySettingsSubPartnersSubPartnerIdRouteRoute,
              ProtectedTenantKeySettingsSubPartnersCreateRouteRoute,
              ProtectedTenantKeySettingsSubPartnersIndexRoute,
            }),
          ProtectedTenantKeySettingsTariffImportJobsRouteRoute:
            ProtectedTenantKeySettingsTariffImportJobsRouteRoute.addChildren({
              ProtectedTenantKeySettingsTariffImportJobsIndexRoute,
            }),
          ProtectedTenantKeySettingsTruckClassImportJobsRouteRoute:
            ProtectedTenantKeySettingsTruckClassImportJobsRouteRoute.addChildren(
              { ProtectedTenantKeySettingsTruckClassImportJobsIndexRoute },
            ),
          ProtectedTenantKeySettingsTruckImportJobsRouteRoute:
            ProtectedTenantKeySettingsTruckImportJobsRouteRoute.addChildren({
              ProtectedTenantKeySettingsTruckImportJobsIndexRoute,
            }),
          ProtectedTenantKeySettingsTruckModelImportJobsRouteRoute:
            ProtectedTenantKeySettingsTruckModelImportJobsRouteRoute.addChildren(
              { ProtectedTenantKeySettingsTruckModelImportJobsIndexRoute },
            ),
          ProtectedTenantKeySettingsTruckModelsRouteRoute:
            ProtectedTenantKeySettingsTruckModelsRouteRoute.addChildren({
              ProtectedTenantKeySettingsTruckModelsTruckModelIdRouteRoute,
              ProtectedTenantKeySettingsTruckModelsCreateRouteRoute,
              ProtectedTenantKeySettingsTruckModelsIndexRoute,
            }),
          ProtectedTenantKeySettingsTruckTypeImportJobsRouteRoute:
            ProtectedTenantKeySettingsTruckTypeImportJobsRouteRoute.addChildren(
              { ProtectedTenantKeySettingsTruckTypeImportJobsIndexRoute },
            ),
          ProtectedTenantKeySettingsTrucksRouteRoute:
            ProtectedTenantKeySettingsTrucksRouteRoute.addChildren({
              ProtectedTenantKeySettingsTrucksTruckIdRouteRoute,
              ProtectedTenantKeySettingsTrucksCreateRouteRoute,
              ProtectedTenantKeySettingsTrucksIndexRoute,
            }),
          ProtectedTenantKeySettingsIndexRoute,
          ProtectedTenantKeySettingsCustomKeySettingsIndexRoute,
        }),
      ProtectedTenantKeyShipmentOrderImportJobsRouteRoute:
        ProtectedTenantKeyShipmentOrderImportJobsRouteRoute.addChildren({
          ProtectedTenantKeyShipmentOrderImportJobsIndexRoute,
        }),
      ProtectedTenantKeyShipmentOrdersRouteRoute,
      ProtectedTenantKeyTourImportJobsRouteRoute:
        ProtectedTenantKeyTourImportJobsRouteRoute.addChildren({
          ProtectedTenantKeyTourImportJobsIndexRoute,
        }),
      ProtectedTenantKeyVehicleDispatchBoardsRouteRoute:
        ProtectedTenantKeyVehicleDispatchBoardsRouteRoute.addChildren({
          ProtectedTenantKeyVehicleDispatchBoardsIndexRoute,
        }),
      ProtectedTenantKeyIndexRoute,
    }),
    ProtectedAdminRouteRoute: ProtectedAdminRouteRoute.addChildren({
      ProtectedAdminIndexRoute,
    }),
    ProtectedIndexRoute,
  }),
  PublicRouteRoute: PublicRouteRoute.addChildren({
    PublicLoginRouteRoute: PublicLoginRouteRoute.addChildren({
      PublicLoginCallbackRouteRoute,
      PublicLoginCognitoRouteRoute,
      PublicLoginIndexRoute,
    }),
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_protected",
        "/_public"
      ]
    },
    "/_protected": {
      "filePath": "_protected/route.tsx",
      "children": [
        "/_protected/$tenantKey",
        "/_protected/admin",
        "/_protected/"
      ]
    },
    "/_public": {
      "filePath": "_public/route.tsx",
      "children": [
        "/_public/login"
      ]
    },
    "/_protected/$tenantKey": {
      "filePath": "_protected/$tenantKey/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/$tenantKey/_performance_managements",
        "/_protected/$tenantKey/settings",
        "/_protected/$tenantKey/shipment-order-import-jobs",
        "/_protected/$tenantKey/shipment-orders",
        "/_protected/$tenantKey/tour-import-jobs",
        "/_protected/$tenantKey/vehicle-dispatch-boards",
        "/_protected/$tenantKey/"
      ]
    },
    "/_protected/admin": {
      "filePath": "_protected/admin/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/admin/"
      ]
    },
    "/_public/login": {
      "filePath": "_public/login/route.tsx",
      "parent": "/_public",
      "children": [
        "/_public/login/callback",
        "/_public/login/cognito",
        "/_public/login/"
      ]
    },
    "/_protected/": {
      "filePath": "_protected/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/$tenantKey/_performance_managements": {
      "filePath": "_protected/$tenantKey/_performance_managements/route.tsx",
      "parent": "/_protected/$tenantKey",
      "children": [
        "/_protected/$tenantKey/_performance_managements/monthly-customer-reports",
        "/_protected/$tenantKey/_performance_managements/monthly-tour-reports",
        "/_protected/$tenantKey/_performance_managements/tours"
      ]
    },
    "/_protected/$tenantKey/settings": {
      "filePath": "_protected/$tenantKey/settings/route.tsx",
      "parent": "/_protected/$tenantKey",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings",
        "/_protected/$tenantKey/settings/contracts",
        "/_protected/$tenantKey/settings/customer-contracts",
        "/_protected/$tenantKey/settings/customers",
        "/_protected/$tenantKey/settings/drivers",
        "/_protected/$tenantKey/settings/own-partner",
        "/_protected/$tenantKey/settings/package-categories",
        "/_protected/$tenantKey/settings/package-category-import-jobs",
        "/_protected/$tenantKey/settings/partners",
        "/_protected/$tenantKey/settings/plan-slots",
        "/_protected/$tenantKey/settings/shipment-categories",
        "/_protected/$tenantKey/settings/shipment-category-import-jobs",
        "/_protected/$tenantKey/settings/site-import-jobs",
        "/_protected/$tenantKey/settings/sites",
        "/_protected/$tenantKey/settings/sub-partners",
        "/_protected/$tenantKey/settings/tariff-import-jobs",
        "/_protected/$tenantKey/settings/truck-class-import-jobs",
        "/_protected/$tenantKey/settings/truck-import-jobs",
        "/_protected/$tenantKey/settings/truck-model-import-jobs",
        "/_protected/$tenantKey/settings/truck-models",
        "/_protected/$tenantKey/settings/truck-type-import-jobs",
        "/_protected/$tenantKey/settings/trucks",
        "/_protected/$tenantKey/settings/",
        "/_protected/$tenantKey/settings/custom-key-settings/"
      ]
    },
    "/_protected/$tenantKey/shipment-order-import-jobs": {
      "filePath": "_protected/$tenantKey/shipment-order-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey",
      "children": [
        "/_protected/$tenantKey/shipment-order-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/shipment-orders": {
      "filePath": "_protected/$tenantKey/shipment-orders/route.tsx",
      "parent": "/_protected/$tenantKey"
    },
    "/_protected/$tenantKey/tour-import-jobs": {
      "filePath": "_protected/$tenantKey/tour-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey",
      "children": [
        "/_protected/$tenantKey/tour-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/vehicle-dispatch-boards": {
      "filePath": "_protected/$tenantKey/vehicle-dispatch-boards/route.tsx",
      "parent": "/_protected/$tenantKey",
      "children": [
        "/_protected/$tenantKey/vehicle-dispatch-boards/"
      ]
    },
    "/_public/login/callback": {
      "filePath": "_public/login/callback/route.tsx",
      "parent": "/_public/login"
    },
    "/_public/login/cognito": {
      "filePath": "_public/login/cognito/route.tsx",
      "parent": "/_public/login"
    },
    "/_protected/$tenantKey/": {
      "filePath": "_protected/$tenantKey/index.tsx",
      "parent": "/_protected/$tenantKey"
    },
    "/_protected/admin/": {
      "filePath": "_protected/admin/index.ts",
      "parent": "/_protected/admin"
    },
    "/_public/login/": {
      "filePath": "_public/login/index.tsx",
      "parent": "/_public/login"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-customer-reports": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-customer-reports/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements",
      "children": [
        "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId",
        "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/",
        "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/"
      ]
    },
    "/_protected/$tenantKey/_performance_managements/monthly-tour-reports": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-tour-reports/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements",
      "children": [
        "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId",
        "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/",
        "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/"
      ]
    },
    "/_protected/$tenantKey/_performance_managements/tours": {
      "filePath": "_protected/$tenantKey/_performance_managements/tours/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements",
      "children": [
        "/_protected/$tenantKey/_performance_managements/tours/$tourId",
        "/_protected/$tenantKey/_performance_managements/tours/create",
        "/_protected/$tenantKey/_performance_managements/tours/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/_users",
        "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories",
        "/_protected/$tenantKey/settings/_system-master-settings/areas",
        "/_protected/$tenantKey/settings/_system-master-settings/charge-types",
        "/_protected/$tenantKey/settings/_system-master-settings/in-house",
        "/_protected/$tenantKey/settings/_system-master-settings/item-units",
        "/_protected/$tenantKey/settings/_system-master-settings/tax-categories",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-classes",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-types"
      ]
    },
    "/_protected/$tenantKey/settings/contracts": {
      "filePath": "_protected/$tenantKey/settings/contracts/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/contracts/create",
        "/_protected/$tenantKey/settings/contracts/",
        "/_protected/$tenantKey/settings/contracts/charter/$contractId",
        "/_protected/$tenantKey/settings/contracts/charter/create",
        "/_protected/$tenantKey/settings/contracts/tariff/$contractId",
        "/_protected/$tenantKey/settings/contracts/tariff/create",
        "/_protected/$tenantKey/settings/contracts/tour/$contractId",
        "/_protected/$tenantKey/settings/contracts/tour/create"
      ]
    },
    "/_protected/$tenantKey/settings/customer-contracts": {
      "filePath": "_protected/$tenantKey/settings/customer-contracts/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/customer-contracts/$customerContractId",
        "/_protected/$tenantKey/settings/customer-contracts/create",
        "/_protected/$tenantKey/settings/customer-contracts/"
      ]
    },
    "/_protected/$tenantKey/settings/customers": {
      "filePath": "_protected/$tenantKey/settings/customers/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/customers/$customerId",
        "/_protected/$tenantKey/settings/customers/create",
        "/_protected/$tenantKey/settings/customers/"
      ]
    },
    "/_protected/$tenantKey/settings/drivers": {
      "filePath": "_protected/$tenantKey/settings/drivers/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/drivers/$userId",
        "/_protected/$tenantKey/settings/drivers/create",
        "/_protected/$tenantKey/settings/drivers/"
      ]
    },
    "/_protected/$tenantKey/settings/own-partner": {
      "filePath": "_protected/$tenantKey/settings/own-partner/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/own-partner/"
      ]
    },
    "/_protected/$tenantKey/settings/package-categories": {
      "filePath": "_protected/$tenantKey/settings/package-categories/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/package-categories/$packageCategoryId",
        "/_protected/$tenantKey/settings/package-categories/create",
        "/_protected/$tenantKey/settings/package-categories/"
      ]
    },
    "/_protected/$tenantKey/settings/package-category-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/package-category-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/package-category-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/partners": {
      "filePath": "_protected/$tenantKey/settings/partners/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/partners/$partnerId",
        "/_protected/$tenantKey/settings/partners/create",
        "/_protected/$tenantKey/settings/partners/"
      ]
    },
    "/_protected/$tenantKey/settings/plan-slots": {
      "filePath": "_protected/$tenantKey/settings/plan-slots/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/plan-slots/"
      ]
    },
    "/_protected/$tenantKey/settings/shipment-categories": {
      "filePath": "_protected/$tenantKey/settings/shipment-categories/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId",
        "/_protected/$tenantKey/settings/shipment-categories/create",
        "/_protected/$tenantKey/settings/shipment-categories/"
      ]
    },
    "/_protected/$tenantKey/settings/shipment-category-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/shipment-category-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/shipment-category-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/site-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/site-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/site-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/sites": {
      "filePath": "_protected/$tenantKey/settings/sites/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/sites/$siteId",
        "/_protected/$tenantKey/settings/sites/create",
        "/_protected/$tenantKey/settings/sites/"
      ]
    },
    "/_protected/$tenantKey/settings/sub-partners": {
      "filePath": "_protected/$tenantKey/settings/sub-partners/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/sub-partners/$subPartnerId",
        "/_protected/$tenantKey/settings/sub-partners/create",
        "/_protected/$tenantKey/settings/sub-partners/"
      ]
    },
    "/_protected/$tenantKey/settings/tariff-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/tariff-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/tariff-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/truck-class-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/truck-class-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/truck-class-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/truck-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/truck-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/truck-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/truck-model-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/truck-model-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/truck-model-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/truck-models": {
      "filePath": "_protected/$tenantKey/settings/truck-models/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/truck-models/$truckModelId",
        "/_protected/$tenantKey/settings/truck-models/create",
        "/_protected/$tenantKey/settings/truck-models/"
      ]
    },
    "/_protected/$tenantKey/settings/truck-type-import-jobs": {
      "filePath": "_protected/$tenantKey/settings/truck-type-import-jobs/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/truck-type-import-jobs/"
      ]
    },
    "/_protected/$tenantKey/settings/trucks": {
      "filePath": "_protected/$tenantKey/settings/trucks/route.tsx",
      "parent": "/_protected/$tenantKey/settings",
      "children": [
        "/_protected/$tenantKey/settings/trucks/$truckId",
        "/_protected/$tenantKey/settings/trucks/create",
        "/_protected/$tenantKey/settings/trucks/"
      ]
    },
    "/_protected/$tenantKey/settings/": {
      "filePath": "_protected/$tenantKey/settings/index.tsx",
      "parent": "/_protected/$tenantKey/settings"
    },
    "/_protected/$tenantKey/shipment-order-import-jobs/": {
      "filePath": "_protected/$tenantKey/shipment-order-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/shipment-order-import-jobs"
    },
    "/_protected/$tenantKey/tour-import-jobs/": {
      "filePath": "_protected/$tenantKey/tour-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/tour-import-jobs"
    },
    "/_protected/$tenantKey/vehicle-dispatch-boards/": {
      "filePath": "_protected/$tenantKey/vehicle-dispatch-boards/index.tsx",
      "parent": "/_protected/$tenantKey/vehicle-dispatch-boards"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-customer-reports",
      "children": [
        "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/"
      ]
    },
    "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-tour-reports",
      "children": [
        "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/"
      ]
    },
    "/_protected/$tenantKey/_performance_managements/tours/$tourId": {
      "filePath": "_protected/$tenantKey/_performance_managements/tours/$tourId/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/tours"
    },
    "/_protected/$tenantKey/_performance_managements/tours/create": {
      "filePath": "_protected/$tenantKey/_performance_managements/tours/create/route.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/tours"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users",
        "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId",
        "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create",
        "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/areas": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/areas/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId",
        "/_protected/$tenantKey/settings/_system-master-settings/areas/create",
        "/_protected/$tenantKey/settings/_system-master-settings/areas/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/charge-types": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/charge-types/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId",
        "/_protected/$tenantKey/settings/_system-master-settings/charge-types/create",
        "/_protected/$tenantKey/settings/_system-master-settings/charge-types/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/in-house": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/in-house/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/in-house/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/item-units": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/item-units/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId",
        "/_protected/$tenantKey/settings/_system-master-settings/item-units/create",
        "/_protected/$tenantKey/settings/_system-master-settings/item-units/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/tax-categories": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/tax-categories/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId",
        "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create",
        "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-classes": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-classes/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-types": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-types/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-types/create",
        "/_protected/$tenantKey/settings/_system-master-settings/truck-types/"
      ]
    },
    "/_protected/$tenantKey/settings/contracts/create": {
      "filePath": "_protected/$tenantKey/settings/contracts/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/customer-contracts/$customerContractId": {
      "filePath": "_protected/$tenantKey/settings/customer-contracts/$customerContractId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/customer-contracts"
    },
    "/_protected/$tenantKey/settings/customer-contracts/create": {
      "filePath": "_protected/$tenantKey/settings/customer-contracts/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/customer-contracts"
    },
    "/_protected/$tenantKey/settings/customers/$customerId": {
      "filePath": "_protected/$tenantKey/settings/customers/$customerId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/customers"
    },
    "/_protected/$tenantKey/settings/customers/create": {
      "filePath": "_protected/$tenantKey/settings/customers/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/customers"
    },
    "/_protected/$tenantKey/settings/drivers/$userId": {
      "filePath": "_protected/$tenantKey/settings/drivers/$userId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/drivers"
    },
    "/_protected/$tenantKey/settings/drivers/create": {
      "filePath": "_protected/$tenantKey/settings/drivers/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/drivers"
    },
    "/_protected/$tenantKey/settings/package-categories/$packageCategoryId": {
      "filePath": "_protected/$tenantKey/settings/package-categories/$packageCategoryId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/package-categories"
    },
    "/_protected/$tenantKey/settings/package-categories/create": {
      "filePath": "_protected/$tenantKey/settings/package-categories/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/package-categories"
    },
    "/_protected/$tenantKey/settings/partners/$partnerId": {
      "filePath": "_protected/$tenantKey/settings/partners/$partnerId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/partners"
    },
    "/_protected/$tenantKey/settings/partners/create": {
      "filePath": "_protected/$tenantKey/settings/partners/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/partners"
    },
    "/_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId": {
      "filePath": "_protected/$tenantKey/settings/shipment-categories/$shipmentCategoryId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/shipment-categories"
    },
    "/_protected/$tenantKey/settings/shipment-categories/create": {
      "filePath": "_protected/$tenantKey/settings/shipment-categories/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/shipment-categories"
    },
    "/_protected/$tenantKey/settings/sites/$siteId": {
      "filePath": "_protected/$tenantKey/settings/sites/$siteId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/sites"
    },
    "/_protected/$tenantKey/settings/sites/create": {
      "filePath": "_protected/$tenantKey/settings/sites/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/sites"
    },
    "/_protected/$tenantKey/settings/sub-partners/$subPartnerId": {
      "filePath": "_protected/$tenantKey/settings/sub-partners/$subPartnerId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/sub-partners"
    },
    "/_protected/$tenantKey/settings/sub-partners/create": {
      "filePath": "_protected/$tenantKey/settings/sub-partners/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/sub-partners"
    },
    "/_protected/$tenantKey/settings/truck-models/$truckModelId": {
      "filePath": "_protected/$tenantKey/settings/truck-models/$truckModelId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-models"
    },
    "/_protected/$tenantKey/settings/truck-models/create": {
      "filePath": "_protected/$tenantKey/settings/truck-models/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-models"
    },
    "/_protected/$tenantKey/settings/trucks/$truckId": {
      "filePath": "_protected/$tenantKey/settings/trucks/$truckId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/trucks"
    },
    "/_protected/$tenantKey/settings/trucks/create": {
      "filePath": "_protected/$tenantKey/settings/trucks/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/trucks"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-customer-reports/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-customer-reports"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-tour-reports/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-tour-reports"
    },
    "/_protected/$tenantKey/_performance_managements/tours/": {
      "filePath": "_protected/$tenantKey/_performance_managements/tours/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/tours"
    },
    "/_protected/$tenantKey/settings/contracts/": {
      "filePath": "_protected/$tenantKey/settings/contracts/index.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/custom-key-settings/": {
      "filePath": "_protected/$tenantKey/settings/custom-key-settings/index.tsx",
      "parent": "/_protected/$tenantKey/settings"
    },
    "/_protected/$tenantKey/settings/customer-contracts/": {
      "filePath": "_protected/$tenantKey/settings/customer-contracts/index.tsx",
      "parent": "/_protected/$tenantKey/settings/customer-contracts"
    },
    "/_protected/$tenantKey/settings/customers/": {
      "filePath": "_protected/$tenantKey/settings/customers/index.tsx",
      "parent": "/_protected/$tenantKey/settings/customers"
    },
    "/_protected/$tenantKey/settings/drivers/": {
      "filePath": "_protected/$tenantKey/settings/drivers/index.tsx",
      "parent": "/_protected/$tenantKey/settings/drivers"
    },
    "/_protected/$tenantKey/settings/own-partner/": {
      "filePath": "_protected/$tenantKey/settings/own-partner/index.tsx",
      "parent": "/_protected/$tenantKey/settings/own-partner"
    },
    "/_protected/$tenantKey/settings/package-categories/": {
      "filePath": "_protected/$tenantKey/settings/package-categories/index.tsx",
      "parent": "/_protected/$tenantKey/settings/package-categories"
    },
    "/_protected/$tenantKey/settings/package-category-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/package-category-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/package-category-import-jobs"
    },
    "/_protected/$tenantKey/settings/partners/": {
      "filePath": "_protected/$tenantKey/settings/partners/index.tsx",
      "parent": "/_protected/$tenantKey/settings/partners"
    },
    "/_protected/$tenantKey/settings/plan-slots/": {
      "filePath": "_protected/$tenantKey/settings/plan-slots/index.tsx",
      "parent": "/_protected/$tenantKey/settings/plan-slots"
    },
    "/_protected/$tenantKey/settings/shipment-categories/": {
      "filePath": "_protected/$tenantKey/settings/shipment-categories/index.tsx",
      "parent": "/_protected/$tenantKey/settings/shipment-categories"
    },
    "/_protected/$tenantKey/settings/shipment-category-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/shipment-category-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/shipment-category-import-jobs"
    },
    "/_protected/$tenantKey/settings/site-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/site-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/site-import-jobs"
    },
    "/_protected/$tenantKey/settings/sites/": {
      "filePath": "_protected/$tenantKey/settings/sites/index.tsx",
      "parent": "/_protected/$tenantKey/settings/sites"
    },
    "/_protected/$tenantKey/settings/sub-partners/": {
      "filePath": "_protected/$tenantKey/settings/sub-partners/index.tsx",
      "parent": "/_protected/$tenantKey/settings/sub-partners"
    },
    "/_protected/$tenantKey/settings/tariff-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/tariff-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/tariff-import-jobs"
    },
    "/_protected/$tenantKey/settings/truck-class-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/truck-class-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-class-import-jobs"
    },
    "/_protected/$tenantKey/settings/truck-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/truck-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-import-jobs"
    },
    "/_protected/$tenantKey/settings/truck-model-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/truck-model-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-model-import-jobs"
    },
    "/_protected/$tenantKey/settings/truck-models/": {
      "filePath": "_protected/$tenantKey/settings/truck-models/index.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-models"
    },
    "/_protected/$tenantKey/settings/truck-type-import-jobs/": {
      "filePath": "_protected/$tenantKey/settings/truck-type-import-jobs/index.tsx",
      "parent": "/_protected/$tenantKey/settings/truck-type-import-jobs"
    },
    "/_protected/$tenantKey/settings/trucks/": {
      "filePath": "_protected/$tenantKey/settings/trucks/index.tsx",
      "parent": "/_protected/$tenantKey/settings/trucks"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId",
        "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create",
        "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users",
      "children": [
        "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId",
        "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create",
        "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/"
      ]
    },
    "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/areas/$areaId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/areas"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/areas/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/areas/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/areas"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/charge-types"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/charge-types/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/charge-types/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/charge-types"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/item-units"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/item-units/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/item-units/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/item-units"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/tax-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/tax-categories/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/tax-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-classes"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-classes/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-classes"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-types"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-types/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-types/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-types"
    },
    "/_protected/$tenantKey/settings/contracts/charter/$contractId": {
      "filePath": "_protected/$tenantKey/settings/contracts/charter/$contractId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/contracts/charter/create": {
      "filePath": "_protected/$tenantKey/settings/contracts/charter/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/contracts/tariff/$contractId": {
      "filePath": "_protected/$tenantKey/settings/contracts/tariff/$contractId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/contracts/tariff/create": {
      "filePath": "_protected/$tenantKey/settings/contracts/tariff/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/contracts/tour/$contractId": {
      "filePath": "_protected/$tenantKey/settings/contracts/tour/$contractId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/settings/contracts/tour/create": {
      "filePath": "_protected/$tenantKey/settings/contracts/tour/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/contracts"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-customer-reports"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId"
    },
    "/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/": {
      "filePath": "_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/index.tsx",
      "parent": "/_protected/$tenantKey/_performance_managements/monthly-tour-reports"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/areas/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/areas/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/areas"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/charge-types/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/charge-types/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/charge-types"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/in-house/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/in-house/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/in-house"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/item-units/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/item-units/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/item-units"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/tax-categories/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/tax-categories/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/tax-categories"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-classes/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-classes/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-classes"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/truck-types/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/truck-types/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/truck-types"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/$userId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/create/route.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users"
    },
    "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/": {
      "filePath": "_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/index.tsx",
      "parent": "/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users"
    }
  }
}
ROUTE_MANIFEST_END */
